export class AccordionAnkerLinks {
    constructor() {
        $('.tx-vet-agenda .c-accordion__header-link ').on('click',function(e) {
            e.preventDefault();

            if($(this).hasClass('collapsed')){
                var $target = $($(this).attr('href'));
                setTimeout(function() {
                    $('html, body').stop().animate({
                        'scrollTop': $target.offset().top - 100
                    }, 900, 'swing');
                }, 500);
            }

        });
    }
}
